import logoBrand from '@/assets/images/favicon.svg'

export function LoadingLogo (): JSX.Element {
  return (
    <div className='w-screen h-screen flex justify-center items-center bg-white flex-col gap-8'>
      <img
        src={logoBrand}
        alt='logo'
        className='w-24 h-24 rounded-full animate-spin-horizontal'
      />
    </div>
  )
}
